import { Link, useLocation } from "react-router-dom";
import classes from "../components/loggedout/LoggedOut.module.scss";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { DDD, E2Data } from "../lib/ddd/ddd";
import { useEffect, useState } from "react";
import axios from "axios";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import { create } from "@mui/material/styles/createTransitions";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const SignUp = () => {
    const [selected, setSelected] = useState("SI");
    const [phone, setPhone] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [candidateId, setCandidateId] = useState(null);
    const [mode, setMode] = useState("init");//init, confirm, finish
    const [identity, setIdentity] = useState("erp");//erp, saas, company

    const { t } = useTranslation();

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        watch,
    } = useForm();
    
    const _setError = (message) => {
        setError(message);
        setTimeout(() => {
            setError(null);
        }, 5000);
    }
    
    const signupSubmit = (data) => {
        const _data ={
            Culture : navigator.language || navigator.userLanguage,
            SignUpType : "Username",
        }
        _data.AdminEmail = data.email;
        _data.AdminLastname = data.lastName;
        _data.AdminName = data.firstName;
        _data.AdminPersonRole = data.role;
        _data.CountryCode = selected;
        _data.TaxNum = data.taxNumber;
        _data.Name = data.businessName;
        _data.Telephone = phone;


        setLoading(true);
        let counter=0;
        let errored = false;
        if(candidateId){
            const e2data2 = new E2Data("OrganisationsReg_Candidates");
            e2data2.values = _data;
            e2data2.filter = "Id='"+candidateId+"'";
            e2data2.Modify().then((response) => {
                setLoading(false);
                console.log(response);
            });

            return;
        }
        const e2data2 = new E2Data("OrganisationsReg_Candidates");
        e2data2.filter = "TaxNum='"+_data.TaxNum+"' AND Registered<>null AND FromDomain='dddinvoices.com'";
        e2data2.GetData().then((response) => {
            setLoading(false);
            if(response?.result?.count > 0)
                return _setError(t("This tax number is already registered"));
            createCandidate(_data);
            /* const e2data1 = new E2Data("OrganisationsReg_Candidates");
            e2data1.filter = "Registered=null AND ForRegistration<>true AND TaxNum='"+_data.TaxNum+"' AND SignUpType='Username' AND FromDomain='dddinvoices.com'";
            e2data1.GetData().then((response) => {
                counter++;
                if(response?.result?.count>0){
                    _setError(t("This tax number waiting to be registered"));
                    errored = true;
                }
    
                if(counter >1){
                    setLoading(false);
                    if(!errored) createCandidate(_data);
                } 
            });
            
    
            const e2data3 = new E2Data("OrganisationsReg_Candidates");
            e2data3.filter = "Registered=null AND ForRegistration<>true AND AdminEmail='"+_data.AdminEmail+"' AND SignUpType='Username' AND FromDomain='dddinvoices.com'";
            e2data3.GetData().then((response) => {
                counter++;
                if(response?.result?.count>0){
                    _setError(t("This email is already waiting to be registered"));
                    errored = true;
                }
                if(counter >1){
                    setLoading(false);
                    if(!errored) createCandidate(_data);
                } 
            }); */
        });
    };

    const userExists = async (email, filterAppend="") => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "SignUpType='Username' AND FromDomain='dddinvoices.com' AND AdminEmail='"+email+filterAppend;
        const response = await e2data.GetData();
        return response?.result?.count>0;
    }

    const taxExists = async (tax, filterAppend="") => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "SignUpType='Username' AND FromDomain='dddinvoices.com' AND TaxNum='"+tax+filterAppend;
        const response = await e2data.GetData();
        return response?.result?.count>0;
    }

    const getMainDomain = () => {
        var parts = window.location.hostname.split('.');
        if (parts.length === 1) {
            // Handle "localhost"
            return window.location.hostname;
        } else {
            // Return the last two parts of the hostname
            return parts.slice(-2).join('.');
        }
    };

    const createCandidate = (_data) => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.values=_data;
        e2data.Create().then((response) => {
            if(response?.result?.affected !== 1)
                return _setError(t("An error occurred while creating the candidate"));

            setCandidateId(response?.result?.values[0].id);
            setMode("confirm");
        });
    }

    const finishCreation = () =>{
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "Id='"+candidateId+"'";
        e2data.values = {ForRegistration : true,}

        //erp, saas, company
        switch(identity){
            case "erp":
                e2data.values["ClientType"] = "ISV";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
            case "saas":
                e2data.values["ClientType"] = "Builder";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
            case "company":
                e2data.values["ClientType"] = "Enterprise";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
                default:
                    break;
        }
        setLoading(true);
        e2data.Modify().then((response) => {
            setLoading(false);
            if(response?.result?.affected !== 1)
                return _setError(t("An error occurred while finishing the registration"));
            setMode("finish");
        });
    }

    return (
    <div className={classes.card}>
        <div className={classes["card-content"]}>
            {mode !== "finish" && <h1 className="text-black">{t("Sign Up")}</h1>}
            {mode==="init" && <><form onSubmit={handleSubmit(signupSubmit)}>
                <label>{t("Business")}*</label>
                <input name="businessName" placeholder={t("Legal name of your business")}  {...register("businessName", {required: t("This field is required")})}/>
                {errors["businessName"] && <p>{errors["businessName"].message}</p>}
                <label>{t("Country and tax number")}*</label>
                <div className={classes["tax-container"]}>
                    {/* Flag selection component goes here */}
                    <ReactFlagsSelect
                        selected={selected}
                        onSelect={(code) => setSelected(code)}
                        className={classes["flag-select"]}
                        searchable
                        searchPlaceholder={t("Search countries")}
                        showSelectedLabel={false}
                        showSecondarySelectedLabel={false}
                        fullWidth={false}
                        selectButtonClassName={classes["menu-flags-button"]}
                    />
                    <input name="taxNumber" placeholder={t("Tax number of the business")} {...register("taxNumber", {required: t("This field is required")})} style={{width: '100%'}} />
                </div>
                {errors["taxNumber"] && <p style={{width: '100%', textAlign:"right"}}>{errors["taxNumber"].message}</p>}
                <label>{t("Contact person")}*</label>
                <div className="d-flex w-100 align-items-center gap-2 flex-column flex-lg-row">
                    <div className="w-100 w-lg-50">
                        <input className="w-100 w-lg-50" name="firstName" {...register("firstName", {required: t("This field is required")})} placeholder={t("First name")} />
                        {errors["firstName"] && <p>{errors["firstName"].message}</p>}
                    </div>
                    <div className="w-100 w-lg-50">
                        <input className="w-100 w-lg-50" name="lastName" {...register("lastName", {required: t("This field is required")})} placeholder={t("Last name")} />
                        {errors["lastName"] && <p>{errors["lastName"].message}</p>}
                    </div>
                </div>
                <label>{t("Email")}*</label>
                <input name="email" placeholder="name@address.com" type="email" {...register("email", {required: t("This field is required")})}/>
                {errors["email"] && <p>{errors["email"].message}</p>}
                <label>{t("Phone Number")}*</label>
                <PhoneInput
                    country={'si'}
                    value={phone}
                    onChange={val => setPhone(val)}
                    className={classes["react-tel-input"]}
                    specialLabel={null}
                    inputStyle={{border:"1px solid rgb(232, 73, 14)", borderRadius:"12px", fontSize:"16px", width:"100%"}}
                    />
                <label>{t("Role")}*</label>
                <select name="role" {...register("role", {required: t("This field is required")})}>
                    <option value="" disabled="" selected="" style={{color: 'rgb(176, 176, 176)'}}>Role</option>
                    <option value="Technician">{t("Developer/CTO/Technical")}</option>
                    <option value="Manager">{t("CEO/Product owner/Business")}</option>
                    <option value="Other">{t("Other")}</option>
                </select>
                {errors["role"] && <p>{errors["role"].message}</p>}
                {error && <div style={{color: "rgb(232, 73, 14)", marginBottom:"1rem"}}>{error}</div>}
                <button type="submit" className={`${classes.btn}`} disabled={loading}>{t("Next")}</button>
            </form>
            </>}
            {mode === "confirm" && <>
                <label>{t("What do you idenfity with the most?")}*</label>
                <div onClick={() => setIdentity("erp")} className={`${classes["large-select"]} ${identity!=="erp" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6002 26.9638C21.2245 26.0013 21.8501 24.7638 22.2997 23.1756C23.3379 23.5744 24.0501 24.0501 24.4874 24.4255C23.3672 25.5381 22.0255 26.4024 20.5494 26.9624H20.6002V26.9638ZM8.50025 24.4131C8.96225 24.0377 9.66212 23.5744 10.7002 23.1619C11.1622 24.7624 11.7631 25.9999 12.3997 26.9624C10.9455 26.3903 9.62596 25.5222 8.525 24.4131H8.50025ZM23.1248 15.2501C23.0862 14.1364 22.9735 13.024 22.7879 11.9254C24.1629 11.4249 25.1625 10.8254 25.8624 10.2754C26.8383 11.7693 27.4427 13.475 27.6251 15.2501H23.1248ZM10.7869 9.47512C10.0593 9.20705 9.37359 8.83666 8.7505 8.37512C9.80432 7.36732 11.0436 6.57349 12.3997 6.03762C11.8126 6.91212 11.2379 8.03687 10.7745 9.47512H10.7882H10.7869ZM20.6002 6.03762C21.9573 6.57176 23.1969 7.36579 24.2495 8.37512C23.6257 8.8355 22.9402 9.2058 22.2131 9.47512C21.8405 8.25672 21.293 7.09883 20.5879 6.03762H20.6002ZM20.35 12.5373C20.4737 13.3623 20.6002 14.2505 20.625 15.2501H12.375C12.4121 14.2505 12.4987 13.3499 12.6252 12.5373C15.1759 12.9965 17.787 12.9965 20.3376 12.5373H20.35ZM16.5 10.3744C15.2487 10.3744 14.1487 10.2754 13.2137 10.1255C14.212 7.04962 15.763 5.81212 16.5 5.37487C17.2122 5.81212 18.7756 7.062 19.7752 10.1255C18.6918 10.2952 17.5966 10.3784 16.5 10.3744ZM7.12525 10.2754C8.05993 10.986 9.10198 11.543 10.2121 11.9254C10.0266 13.025 9.91402 14.1357 9.87525 15.2501H5.324C5.52142 13.4706 6.14341 11.7645 7.13762 10.2754H7.12525ZM5.33775 17.7499H9.87525C9.92475 18.8251 9.999 19.8124 10.1502 20.713C8.9986 21.1086 7.92402 21.7003 6.974 22.462C6.07493 21.0362 5.51079 19.4251 5.324 17.7499H5.33775ZM16.5 19.7505C15.0012 19.7505 13.7129 19.8743 12.5881 20.075C12.4782 19.3045 12.4071 18.5289 12.375 17.7512H20.625C20.5879 18.5872 20.5246 19.3738 20.4256 20.075C19.1304 19.8409 17.8162 19.7281 16.5 19.7381V19.7505ZM16.5 27.6251C15.7506 27.1755 14.1006 25.8376 13.0996 22.5005C14.2235 22.3173 15.3614 22.2336 16.5 22.2502C17.8131 22.2502 18.9379 22.3369 19.9127 22.5005C18.9131 25.8748 17.2631 27.1755 16.5124 27.6251H16.5ZM26.0246 22.4496C25.0758 21.6869 24.0015 21.0951 22.8497 20.7006C23.0004 19.7234 23.0923 18.7381 23.1248 17.7499H27.676C27.4874 19.4208 26.9219 21.0275 26.0246 22.4496ZM16.5 2.75C8.90587 2.75 2.75 8.90588 2.75 16.5C2.75 24.0941 8.90587 30.25 16.5 30.25C24.0941 30.25 30.25 24.0941 30.25 16.5C30.25 8.90588 24.0941 2.75 16.5 2.75Z" fill="#b0b0b0"></path>
                        </svg>
                    </div>
                    <div class="text-start">{t("I am a SaaS / ERP / accounting software vendor that wants to enable e-invoicing for users (API connection).")}</div>
                </div>
                <div onClick={() => setIdentity("saas")} className={`${classes["large-select"]} ${identity!=="saas" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 1.02148C30 0.457064 29.5159 0 28.9197 0H18V4.11587C18.2709 3.97292 18.5828 3.89189 18.9145 3.89189C19.9556 3.89189 20.8001 4.69029 20.8001 5.67583C20.8001 6.66043 19.9561 7.45927 18.9145 7.45927C18.5828 7.45927 18.2709 7.37779 18 7.2358V11.3512H22.3509C22.2004 11.6075 22.1142 11.9024 22.1142 12.2161C22.1142 13.2015 22.9582 14 24 14C25.0413 14 25.8853 13.2015 25.8853 12.2161C25.8853 11.9024 25.7992 11.6075 25.6491 11.3512H30V1.02148Z" fill="#b0b0b0"></path>
                            <path d="M25.4566 16.0361H19.9581C19.7656 16.0361 19.5874 16.1379 19.49 16.303L19.4953 16.2939L19.489 16.304C19.4393 16.3885 19.4142 16.484 19.4142 16.5791C19.4142 16.6699 19.4374 16.7615 19.4827 16.8437L19.8293 17.4677C19.907 17.6082 19.9451 17.7559 19.9456 17.9171C19.9452 18.1661 19.8496 18.3958 19.6739 18.5725C19.4973 18.7482 19.2671 18.8438 19.0184 18.8447C18.7694 18.8437 18.5392 18.7482 18.362 18.5725L18.3627 18.5735C18.1865 18.3959 18.0912 18.1657 18.0907 17.9171C18.0912 17.7564 18.1293 17.6082 18.2068 17.4673L18.5536 16.8437C18.5992 16.7616 18.6221 16.6705 18.6221 16.5792C18.6221 16.4841 18.597 16.3886 18.5465 16.3031C18.4488 16.1376 18.2707 16.0362 18.0784 16.0362H13.9643V13.8329C14.7078 13.8213 15.4101 13.5283 15.9361 13.0012C16.4748 12.464 16.7731 11.7434 16.7726 10.9823C16.773 10.2202 16.4745 9.49959 15.9361 8.96286C15.4105 8.43573 14.708 8.14325 13.9643 8.1317V4.54348C13.964 4.2433 13.7207 4 13.4206 4H2.04712C1.50174 3.99959 0.984096 4.21338 0.599417 4.599C0.217405 4.98131 0.000474819 5.50595 7.84883e-07 6.04748V27.9531C-0.000473249 28.498 0.21379 29.0154 0.599417 29.4005C0.981725 29.7823 1.50559 29.9995 2.04712 30H23.955C24.4951 29.9995 25.0192 29.7823 25.401 29.4005C25.7867 29.0154 26.0005 28.4984 26 27.9531V16.5796C26.0001 16.2794 25.7568 16.0361 25.4566 16.0361ZM1.68104 6.04748C1.68104 5.92198 1.73947 5.83659 1.78723 5.78878C1.83671 5.73954 1.92185 5.68064 2.04712 5.68064H12.2831V10.0419C12.2831 10.1472 12.3389 10.2442 12.4294 10.2977C12.4757 10.3248 12.5275 10.3383 12.5797 10.3383C12.6294 10.3383 12.6789 10.3263 12.7238 10.3012L13.3476 9.95461C13.5235 9.85707 13.7152 9.80736 13.9169 9.80736C14.2304 9.80736 14.5255 9.92948 14.7473 10.151C14.9693 10.3735 15.0915 10.6689 15.0915 10.9822C15.0915 11.2954 14.9693 11.5904 14.7478 11.8124C14.5255 12.0344 14.2304 12.1565 13.9169 12.1565C13.7149 12.1565 13.5235 12.1068 13.3479 12.0093L12.7235 11.6627C12.6789 11.6376 12.6292 11.6255 12.5797 11.6255C12.5276 11.6255 12.4757 11.639 12.4294 11.6666C12.3389 11.7197 12.2832 11.8167 12.2832 11.9219V16.2832H9.58266C9.58799 16.2161 9.5906 16.1491 9.5906 16.0829C9.5906 15.3855 9.3191 14.7305 8.82657 14.2387C8.33453 13.7459 7.67953 13.4747 6.98211 13.4747C6.28492 13.4747 5.62998 13.7459 5.13812 14.2382C4.64512 14.73 4.37362 15.3855 4.37385 16.0825C4.37385 16.1491 4.37646 16.2157 4.38179 16.2833H1.68104V6.04748ZM12.2832 28.3194H2.04712C1.92185 28.3194 1.8367 28.2605 1.78841 28.2127C1.73947 28.1635 1.68104 28.078 1.68104 27.9531V17.7163H6.0421C6.1471 17.7163 6.24433 17.6608 6.29766 17.5705C6.35099 17.4798 6.35247 17.3678 6.30134 17.2761L5.95505 16.652C5.85728 16.4758 5.80781 16.2842 5.80757 16.0829C5.80781 15.7697 5.93023 15.4743 6.15124 15.2523C6.37392 15.0308 6.66913 14.9081 6.98211 14.9081C7.29509 14.9081 7.59029 15.0308 7.81226 15.2518C8.03405 15.4743 8.15641 15.7697 8.15665 16.0824C8.15641 16.2846 8.10664 16.4763 8.00987 16.6515L7.66282 17.2756C7.61163 17.3678 7.61317 17.4798 7.66649 17.57C7.71982 17.6607 7.81712 17.7162 7.92206 17.7162H12.2831V20.4177C12.216 20.4124 12.1492 20.41 12.0831 20.41C11.3854 20.41 10.7304 20.6812 10.2391 21.1735C9.74584 21.6658 9.47458 22.3208 9.47505 23.0177C9.47458 23.7147 9.74585 24.3702 10.2387 24.862C10.7305 25.3548 11.3855 25.626 12.0831 25.626C12.1497 25.626 12.2166 25.6236 12.2832 25.6183V28.3194ZM24.3194 27.9531C24.3194 28.078 24.2605 28.163 24.2122 28.2118C24.163 28.2605 24.078 28.3194 23.9531 28.3194H13.7171V23.9581C13.7171 23.8529 13.6617 23.7559 13.5709 23.7028C13.5245 23.6752 13.4726 23.6618 13.4206 23.6618C13.3711 23.6618 13.3214 23.6739 13.2767 23.6989L12.6519 24.0455C12.4765 24.143 12.2851 24.1927 12.0831 24.1927C11.7701 24.1927 11.4749 24.0702 11.2529 23.849C11.0311 23.627 10.9088 23.3316 10.9085 23.0183C10.9088 22.7046 11.0312 22.4097 11.2527 22.1877C11.4745 21.9662 11.7696 21.8436 12.0831 21.8431C12.2837 21.8431 12.4753 21.8928 12.652 21.9903L13.2765 22.3373C13.3214 22.3624 13.3708 22.3745 13.4206 22.3745C13.4727 22.3745 13.5246 22.361 13.5709 22.334C13.6614 22.2804 13.7172 22.1834 13.7172 22.0781V17.7164H16.4179C16.4126 17.7834 16.4099 17.8506 16.4099 17.9171C16.4097 18.6136 16.681 19.2686 17.1735 19.7609C17.6658 20.2542 18.321 20.5254 19.0182 20.5254C19.7154 20.5254 20.3704 20.2542 20.8627 19.7614C21.3555 19.2696 21.6263 18.6146 21.6263 17.9172C21.6263 17.8506 21.6238 17.784 21.6186 17.7164H24.3195V27.9531H24.3194Z" fill="#b0b0b0"></path>
                        </svg>
                    </div>
                    <div class="text-start">{t("I am building a SaaS invoicing solution and want to significantly shorten my development cycle.")}</div>
                </div>
                <div onClick={() => setIdentity("company")} className={`${classes["large-select"]} ${identity!=="company" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.7 26H24.3C25.785 26 27 24.7916 27 23.3146V7.01432C27 5.53736 25.785 4.32894 24.3 4.32894H20.052V2.28804C19.944 0.9364 18.765 -0.0840466 17.406 0.00546626H9.594C8.235 -0.0840466 7.056 0.9364 6.948 2.28804V4.32894H2.7C1.215 4.32894 0 5.53736 0 7.01432V23.3146C0 24.7916 1.215 26 2.7 26ZM8.748 2.28804C8.748 2.06426 9.117 1.79572 9.594 1.79572H17.406C17.883 1.79572 18.252 2.06426 18.252 2.28804V4.32894H8.748V2.28804ZM1.8 16.4311H5.04V15.5986C5.04 15.1063 5.445 14.7035 5.94 14.7035H9.297C9.792 14.7035 10.197 15.1063 10.197 15.5986V16.4311H16.803V15.5986C16.803 15.1063 17.208 14.7035 17.703 14.7035H21.06C21.555 14.7035 21.96 15.1063 21.96 15.5986V16.4311H25.2V18.2213H21.96V18.4183C21.96 19.8326 20.808 20.9873 19.386 20.9873C17.964 20.9873 16.803 19.8415 16.803 18.4272V18.2303H10.197V18.4272C10.197 19.8415 9.045 20.9962 7.623 20.9962C6.201 20.9962 5.04 19.8326 5.04 18.4183V18.2213H1.8V16.4311Z" fill="#435288"></path>
                        </svg>
                    </div>
                    <div class="text-start">{t("I am a company that has to comply with the e-invoicing regulations and / or wants to connect to an e-invoicing network.")}</div>
                </div>
                <button onClick={finishCreation} className={`${classes.btn}`} disabled={loading}>{t("Submit")}</button>
            </>}
            {mode === "finish" && <>
                <h2>{t("Thank you for registering!")}</h2>
                <p className="mt-2">{t("We will get back to you shortly via email.")}</p>

                <span><Link onClick={() => window.location = "@"} className={classes["main-blue-link"]}>{t("Back to homepage")}</Link></span>
            </>}
            {mode ==="init" && <p className="mt-4 mb-0" style={{fontSize: '10px'}}>{t("By continuing you agree to our")} <a href="@terms-and-conditions-ddd">Terms &amp; conditions</a> and <a href="@privacy-policy-ddd">{t("Privacy policy")}</a>. </p>}
        </div>
    </div>
    );
};

export default SignUp;